<template>
  <div id="index">
      <el-container>
        <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
          <el-main>
            <el-row :gutter="24">
              <el-col :xs="1" :sm="2" :lg="4" v-html="'&nbsp;'"></el-col>
              <el-col :xs="24" :sm="20" :lg="16">
                <div class="BeingSoon">
                  <el-row :gutter="24">
                    <el-col :xs="24" :sm="12" style="text-align: center">
                      <img src="~assets/img/openingsoon.png" style="margin-top: 20px;width: 100%;" />
                    </el-col>
                    <el-col :xs="24" :sm="12">
                      <h3>{{$t("desc.beingDevelop")}}...</h3>
                      <h4>{{$t("desc.comeSoon")}}！</h4>
                      <span>{{$t("desc.developInfo")}}...</span>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
              <el-col :xs="1" :sm="2" :lg="4"> &nbsp; </el-col>
            </el-row>
          </el-main>
        </el-scrollbar>
      </el-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "index",
  data() {
    return {};
  },
  computed: mapState({
    isCollapse: (state) => state.isCollapse,
    navselected: (state) => state.adminleftnavnum,
  }),
  methods: {
    openNotice() {
      this.$notify({
        title: "警告",
        message: "这是一条警告的提示消息",
        type: "warning",
      });
    },
    togleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
  },
};
</script>

<style>
</style>
